/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 他社乗車の場所
 * @export
 * @interface NeighborPickupsRow
 */
export interface NeighborPickupsRow {
    /**
     * 空車での trip_session_id
     * @type {string}
     * @memberof NeighborPickupsRow
     */
    unladenTripSessionId?: string;
    /**
     * 空車開始時刻(UTC, フォーマット '2023-05-02T04:13:18Z')
     * @type {string}
     * @memberof NeighborPickupsRow
     */
    unladenStartTs?: string;
    /**
     * neighbor_pickup_status
     * @type {string}
     * @memberof NeighborPickupsRow
     */
    neighborPickupStatus?: string;
    /**
     * neighbor_pickup_trip_session_id
     * @type {string}
     * @memberof NeighborPickupsRow
     */
    neighborPickupTripSessionId?: string;
    /**
     * entry_time
     * @type {string}
     * @memberof NeighborPickupsRow
     */
    entryTime?: string;
    /**
     * neighbor_pickup_entry_time
     * @type {string}
     * @memberof NeighborPickupsRow
     */
    neighborPickupEntryTime?: string;
    /**
     * pickup_loc_coords
     * @type {object}
     * @memberof NeighborPickupsRow
     */
    pickupLocCoords?: object;
    /**
     * 乗車種別 (cruising/stand/go/tel/cancel_tel/homing/error)
     * @type {string}
     * @memberof NeighborPickupsRow
     */
    neighborBoardingType?: string;
    /**
     * check_speed
     * @type {string}
     * @memberof NeighborPickupsRow
     */
    checkSpeed?: string;
}

export function NeighborPickupsRowFromJSON(json: any): NeighborPickupsRow {
    return NeighborPickupsRowFromJSONTyped(json, false);
}

export function NeighborPickupsRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): NeighborPickupsRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unladenTripSessionId': !exists(json, 'unladen_trip_session_id') ? undefined : json['unladen_trip_session_id'],
        'unladenStartTs': !exists(json, 'unladen_start_ts') ? undefined : json['unladen_start_ts'],
        'neighborPickupStatus': !exists(json, 'neighbor_pickup_status') ? undefined : json['neighbor_pickup_status'],
        'neighborPickupTripSessionId': !exists(json, 'neighbor_pickup_trip_session_id') ? undefined : json['neighbor_pickup_trip_session_id'],
        'entryTime': !exists(json, 'entry_time') ? undefined : json['entry_time'],
        'neighborPickupEntryTime': !exists(json, 'neighbor_pickup_entry_time') ? undefined : json['neighbor_pickup_entry_time'],
        'pickupLocCoords': !exists(json, 'pickup_loc_coords') ? undefined : json['pickup_loc_coords'],
        'neighborBoardingType': !exists(json, 'neighbor_boarding_type') ? undefined : json['neighbor_boarding_type'],
        'checkSpeed': !exists(json, 'check_speed') ? undefined : json['check_speed'],
    };
}

export function NeighborPickupsRowToJSON(value?: NeighborPickupsRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'unladen_trip_session_id': value.unladenTripSessionId,
        'unladen_start_ts': value.unladenStartTs,
        'neighbor_pickup_status': value.neighborPickupStatus,
        'neighbor_pickup_trip_session_id': value.neighborPickupTripSessionId,
        'entry_time': value.entryTime,
        'neighbor_pickup_entry_time': value.neighborPickupEntryTime,
        'pickup_loc_coords': value.pickupLocCoords,
        'neighbor_boarding_type': value.neighborBoardingType,
        'check_speed': value.checkSpeed,
    };
}


